import React from "react";
import {
  EnrollmentFormCol,
  EnrollmentFormRow,
  EnrollmentStepFooter,
} from "../components/styles/Enrollment.styled";
import { Dropdown, Form, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "../components/styles/Button.styled";
import { FormError } from "../components/enrollment/FormError";
import { RadioBox } from "../components/enrollment/RadioBox";
import { usePlacesWidget } from "react-google-autocomplete";
import { statesList } from "../states-list";
import { handlePlaceSelect } from "../common/utils";
import Datetime from "react-datetime";
import jsonToArrConverter from "../utils/jsonToArrConverter";
import moment from "moment";

const nonTxStates = statesList.filter((val) => val.abbr !== "TX");

interface StepServiceCroProps {
  address: string;
  setAddress: (address: string) => void;
  unitNo: string;
  setUnitNo: (unitNo: string) => void;
  selectedState: any;
  setSelectedState: (state: any) => void;
  city: string;
  setCity: (city: string) => void;
  serviceType: any;
  setServiceType: any;
  serviceTypeOptions: Array<{ value: string; label: string }>;
  errorFields: { [key: string]: string };
  loading: boolean;
  handleSave: () => void;
  renderSpecialInput: () => JSX.Element | null;
  isFromCro?: boolean;
  selectedCounty: string | undefined;
  setSelectedCounty: (county: any) => void;
  croZipcode: string;
  setCroZipcode: (zipCode: string) => void;
  utilityList: any[];
  startDate: any;
  setStartDate: (date: any) => void;
  holidays?: any;
  utilityLoading: boolean;
}

const StepServiceCro = ({
  croZipcode,
  setCroZipcode,
  address,
  setAddress,
  unitNo,
  setUnitNo,
  selectedState,
  setSelectedState,
  selectedCounty,
  setSelectedCounty,
  serviceType,
  setServiceType,
  serviceTypeOptions,
  errorFields,
  loading,
  handleSave,
  renderSpecialInput,
  isFromCro,
  city,
  setCity,
  utilityList,
  startDate,
  setStartDate,
  holidays,
  utilityLoading,
}: StepServiceCroProps) => {
  const { t, i18n } = useTranslation("enrollment");

  const { ref } = usePlacesWidget<HTMLInputElement>({
    apiKey: "AIzaSyAcGkZI81wg0GRI5x46cPUSKPn_uzBfmuQ",
    options: {
      types: ["address"],
      componentRestrictions: { country: "us" },
    },
    onPlaceSelected: (place) => {
      console.log({ place });
      const fields = handlePlaceSelect(place);
      const {
        responseState,
        responseCounty,
        responseCity,
        responseZipCode,
        responseUnitNo,
        responseAddressLine,
      } = fields;
      console.log({ fields });
      setAddress(responseAddressLine);
      setCity(responseCity);
      setCroZipcode(responseZipCode);
      setSelectedCounty(responseCounty);
      setUnitNo(responseUnitNo);
      setSelectedState(responseState || ".");
    },
  });

  return (
    <div className="mt-5">
      <h6 style={{ marginBottom: -20 }}>{t("Service Address")}</h6>

      <EnrollmentFormRow>
        <EnrollmentFormCol full>
          <Form.Group className={errorFields["service_address"] ? "error" : ""}>
            <Form.Label>{t("Address")} *</Form.Label>
            <Form.Control
              ref={ref}
              type="text"
              name="service_address"
              placeholder=""
              maxLength={200}
              value={address}
              onChange={(evt) => setAddress(evt.target.value)}
              disabled={loading}
            />
          </Form.Group>
          <FormError message={errorFields["service_address"]} />
        </EnrollmentFormCol>
        <EnrollmentFormCol>
          <Form.Group className={errorFields["service_unit"] ? "error" : ""}>
            <Form.Label>{t("Unit/Suite/Apt Number")}</Form.Label>
            <Form.Control
              type="text"
              name="service_unit"
              placeholder=""
              maxLength={50}
              value={unitNo}
              onChange={(evt) => setUnitNo(evt.target.value)}
              disabled={loading}
            />
          </Form.Group>
          <FormError message={errorFields["service_unit"]} />
        </EnrollmentFormCol>
        <EnrollmentFormCol>
          <Form.Group className={errorFields["service_city"] ? "error" : ""}>
            <Form.Label>{t("City")} *</Form.Label>
            <Form.Control
              type="text"
              name="service_city"
              placeholder=""
              maxLength={50}
              disabled={loading}
              value={city}
              onChange={(evt) => setCity(evt.target.value)}
            />
          </Form.Group>
          <FormError message={errorFields["service_city"]} />
        </EnrollmentFormCol>
        <EnrollmentFormCol>
          <Form.Group className={errorFields["service_county"] ? "error" : ""}>
            <Form.Label>{t("County")} *</Form.Label>
            <Form.Control
              type="text"
              name="service_county"
              placeholder=""
              maxLength={50}
              disabled={loading}
              value={selectedCounty}
              onChange={(evt) => setSelectedCounty(evt.target.value)}
            />
          </Form.Group>
          <FormError message={errorFields["service_city"]} />
        </EnrollmentFormCol>
        <EnrollmentFormCol>
          <Form.Group className={errorFields["service_state"] ? "error" : ""}>
            <Form.Label>{t("State")} *</Form.Label>
            <Dropdown className="plans-filter-dd">
              <Dropdown.Toggle variant="outline-secondary">
                {selectedState ? selectedState.name : "State..."}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {nonTxStates.map((val, idx) => (
                  <Dropdown.Item
                    eventKey={val.abbr}
                    key={idx}
                    onClick={() => setSelectedState(val)}
                    active={selectedState?.abbr === val.abbr}
                  >
                    {val.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
          <FormError message={errorFields["service_state"]} />
        </EnrollmentFormCol>
        <EnrollmentFormCol>
          <Form.Group className={errorFields["service_unit"] ? "error" : ""}>
            <Form.Label>{t("Zip code*")}</Form.Label>
            <Form.Control
              type="text"
              name="service_zipcode"
              placeholder=""
              maxLength={5}
              value={croZipcode}
              onChange={(evt) => {
                setCroZipcode(evt.target.value);
              }}
              disabled={loading}
            />
          </Form.Group>
          <FormError message={errorFields["service_zipcode"]} />
        </EnrollmentFormCol>
        <EnrollmentFormCol></EnrollmentFormCol>
        {renderSpecialInput()}
      </EnrollmentFormRow>
      {serviceTypeOptions.length ? (
        <EnrollmentFormRow>
          <EnrollmentFormCol full>
            <Form.Group className={errorFields["serviceType"] ? "error" : ""}>
              <RadioBox
                title={`${t("Why do you need this service?")} *`}
                options={serviceTypeOptions}
                select={serviceType}
                handleSelect={(val: any) => {
                  setServiceType(val);
                }}
              />
              <FormError message={errorFields["serviceType"]} />
            </Form.Group>
          </EnrollmentFormCol>
        </EnrollmentFormRow>
      ) : null}
      {serviceType &&
        serviceType.value !== "3" &&
        serviceType.value !== "-1" && (
          <>
            <EnrollmentFormRow>
              <EnrollmentFormCol>
                <Form.Group className={errorFields["startDate"] ? "error" : ""}>
                  <Form.Label>{t("Select Date")} *</Form.Label>
                  <Datetime
                    locale={i18n.language === "es" ? "es" : "en"}
                    value={startDate}
                    onChange={(date: any) => setStartDate(date)}
                    dateFormat="MM/DD/YYYY"
                    timeFormat={false}
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: t("MM/DD/YYYY"),
                      id: "select-start-date",
                      readOnly: true,
                    }}
                    isValidDate={(currentDate) => {
                      if (holidays) {
                        if (
                          currentDate.isBefore(moment().format("YYYY-MM-DD")) ||
                          currentDate.isAfter(
                            moment(holidays.end_date, "YYYY-MM-DD")
                          )
                        )
                          return false;
                        const blackoutDate = jsonToArrConverter(
                          holidays.blackout_dates
                        )?.filter(
                          (val: string) =>
                            val.indexOf(
                              moment(currentDate).format("YYYY-MM-DD")
                            ) >= 0
                        );
                        if (blackoutDate.length > 0) return false;
                        return true;
                      } else if (
                        currentDate.isBefore(moment().format("YYYY-MM-DD"))
                      ) {
                        return false;
                      }
                      return true;
                    }}
                  />
                </Form.Group>
                <FormError message={errorFields["startDate"]} />
              </EnrollmentFormCol>
            </EnrollmentFormRow>
            <p style={{ marginTop: -20, fontSize: 14, color: "#666" }}>
              {t(
                "It may take 24 - 48 hours from your service request date for services to be connected."
              )}
            </p>
            <p style={{ fontSize: 14, color: "#666" }}>
              {t(
                "Please note that CleanSky Energy will submit your enrollment request for the date that you select, but actual connectivity of service is determined by your local utility provider. Service connectivity may not be available on weekends or holidays in some areas."
              )}
            </p>
          </>
        )}
      <EnrollmentStepFooter>
        <div />
        <Button
          type="button"
          disabled={loading || utilityLoading}
          onClick={() => handleSave()}
          data-test-id="cta"
        >
          <span>{t("Continue")}</span>
          {(loading || utilityLoading) && (
            <Spinner
              animation="border"
              variant="light"
              size="sm"
              className="ms-2"
            />
          )}
        </Button>
      </EnrollmentStepFooter>
    </div>
  );
};

export default StepServiceCro;
